import { put, select, takeEvery } from 'redux-saga/effects'
import * as formActions from 'components/submitForm/actions'
import * as questionsActions from 'components/questions/actions'
import { ActionType } from 'typesafe-actions'
import { RootState } from 'stores/index'
import questions from 'locales/questions.de.yml'
import { setCompleteness } from './actions'

// eMail validation copied from https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/email#Validation
const eMailValidation = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/

/**
 * Check if all the necessary stuff has been filled out
 * @param state
 */
export const hasEverythingBeenFilledOut = (state: RootState): boolean => {
  return (
    // Has the user confirmed the terms and conditions?
    state.form.confirmedTerms &&
    // Did they enter a valid mail address
    eMailValidation.test(state.form.emailAddress) &&
    // Did they enter a number for Aryas victims
    (state.selectedAnswers['aryaVictims'] ||
      state.selectedAnswers['aryaVictims'] === 0) &&
    // Are there answers for every category
    questions.every(({ id, selectionType }) => {
      const limit = selectionType === 'multiple' ? 0 : 1
      return (
        state.selectedAnswers[id] && state.selectedAnswers[id].size >= limit
      )
    })
  )
}

export function* checkForCompleteness() {
  yield takeEvery(
    (
      action:
        | ActionType<typeof formActions>
        | ActionType<typeof questionsActions>
    ) => /^@form/.test(action.type) || /^@questions/.test(action.type),
    function*() {
      const state: RootState = yield select(state => state)
      yield put(setCompleteness(hasEverythingBeenFilledOut(state)))
    }
  )
}
